module.exports = __webpack_public_path__ + "static/media/less.f7d47a59.svg";